module.exports = __webpack_public_path__ + "static/media/Logo.38a4d24b.svg";